import { Language } from '../services/languages/languages.interfaces';
import { UserSettings } from '../services/users/users.interfaces';

export class AppUser {
  userName = '';
  password = '';
}
export interface EncryptedUser {
  email: string;
  password: string;
}

export class AppUserAuth {
  userId = 0;
  userName = '';
  fullName = '';
  accessToken = '';
  refreshToken = '';
  language: Language | null = null;
  userSettings: UserSettings | null = null;
  isAuthenticated = false;
  isActivated = false;
  claims: AppUserClaim[] = [];
  mqttUsername?: string;
  mqttPassword?: string;
  appLogLevel?: number;
}

export class AppUserClaim {
  claimId = '';
  userId = '';
  claimType = '';
  claimValue = '';
}
